// MB-1396: failure reason attached by the api to a FAILED progressUpdate (and
// to the 503 body of /services/check-video) when the video service itself was
// unreachable — the copy tells the user to retry later instead of implying the
// content was at fault.
export const SERVICE_UNAVAILABLE_REASON = "SERVICE_UNAVAILABLE";

export const VIDEO_SERVICE_UNAVAILABLE_CODE = "VIDEO_SERVICE_UNAVAILABLE";

export const VIDEO_SERVICE_UNAVAILABLE_MESSAGE =
    "Video service is temporarily unavailable. Please try again in a few minutes.";
